<template>
  <g>
    <circle cx="12" cy="12.0002" r="9" fill="white" />
    <path
      d="M12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM12 20.0002C7.58 20.0002 4 16.4202 4 12.0002C4 7.58018 7.58 4.00018 12 4.00018C16.42 4.00018 20 7.58018 20 12.0002C20 16.4202 16.42 20.0002 12 20.0002Z"
    />
    <path
      d="M12 17.0002C14.7614 17.0002 17 14.7616 17 12.0002C17 9.23876 14.7614 7.00018 12 7.00018C9.23858 7.00018 7 9.23876 7 12.0002C7 14.7616 9.23858 17.0002 12 17.0002Z"
    />
  </g>
</template>
